var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H73V73H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1945 61.0042L24.7809 57.6234C25.8587 59.5343 26.8391 61.151 29.1907 61.151C31.4449 61.151 32.8661 60.2692 32.8661 56.8394V33.5142H39.7262V56.9364C39.7262 64.0417 35.5613 67.2759 29.4848 67.2759C23.9969 67.2759 20.8113 64.4336 19.1943 61.0036",
    fill: "#161631"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4524 60.2693L49.0382 57.0351C50.5086 59.4365 52.4197 61.2004 55.8006 61.2004C58.6431 61.2004 60.4557 59.7792 60.4557 57.8191C60.4557 55.467 58.5938 54.6339 55.4575 53.2623L53.743 52.5267C48.7934 50.4201 45.5102 47.774 45.5102 42.1876C45.5102 37.0424 49.4303 33.1221 55.5558 33.1221C59.917 33.1221 63.0531 34.6413 65.307 38.6105L59.9657 42.0405C58.7896 39.9335 57.5159 39.1007 55.5559 39.1007C53.5468 39.1007 52.2726 40.3747 52.2726 42.0405C52.2726 44.0986 53.5468 44.9318 56.4866 46.206L58.2015 46.941C64.0328 49.4402 67.3161 51.988 67.3161 57.7211C67.3161 63.8957 62.465 67.2766 55.9478 67.2766C49.5776 67.2766 45.4612 64.2386 43.4524 60.2693Z",
    fill: "#161631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.5d7271f4e3fcf8af560ab992d4a0528c.svg";
export { ForwardRef as ReactComponent };